export default "__VITE_ASSET__D8dZpS0O__"